import { GeocodeResult } from 'src/interfaces';
import { IDeserializable } from './deserializable.model';

export class Address implements IDeserializable {

  public id: number;
  public line1: string;
  public line2: string;
  public town: string;
  public city: string;
  public postcode: string;
  public country: string;
  public lat: number;
  public lng: number;
  public notes: string;
  public customerId: number;
  public appointmentsCount?: number;
  public isMostRecentlyUsed?: number;
  public formattedAddress?: string;
  public w3w?: string;


  public getAddressSummary(singleLine?: boolean) {
    const joiner = (singleLine) ? ', ' : '<br>';
    let out = (this.line1) ? this.line1 : '';
    out += (this.town) ? joiner + this.town : '';
    return out;
  }

  public getFullSummary(singleLine?: boolean) {
    const joiner = (singleLine) ? ', ' : '<br>';
    let out = (this.line1) ? this.line1 : '';
    out += (this.line2) ? joiner + this.line2  : '';
    out += (this.town) ? joiner + this.town : '';
    out += (this.city) ? joiner + this.city : '';
    out += (this.postcode) ? joiner + this.postcode : '';
    return out;
  }

  public static fromGeocodeResult(geocodeResult: GeocodeResult): Address {
    const address = new Address();
    
    const getAddressComponent = (types: string[]) => {
        const component = geocodeResult.address_components.find(ac => 
            types.every(type => ac.types.includes(type))
        );
        return component ? component.long_name : '';
    };

    address.line1 = getAddressComponent(['street_number']) + ' ' + getAddressComponent(['route']);
    address.line2 = ''; // Assuming no direct mapping from geocodeResult
    address.town = getAddressComponent(['locality', 'political']);
    address.city = getAddressComponent(['postal_town']);
    address.postcode = getAddressComponent(['postal_code']);
    address.country = getAddressComponent(['country', 'political']);
    address.lat = geocodeResult.geometry.location.lat;
    address.lng = geocodeResult.geometry.location.lng;
    address.formattedAddress = geocodeResult.formatted_address
    
    return address;
}

  public deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }



}
